import type { FaireProductEntity } from "../../entity_types/product";

export const p_37y9x36tqe: FaireProductEntity = {
  token: "p_37y9x36tqe",
  type: "product",
  name: "Ceramic Red stripe plate, 6.3x6.3 Inches",
  brandToken: "b_9f715f8d",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/20dfc90d356b7200f3b79f87b534dee12e4ecac4a65399a1433059c2e8e8661f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6f35fba1d88fceed67477f69a285a68bd51ea37732c4051b65c1e1200fccaf8b.jpeg",
    "https://cdn.faire.com/fastly/ea5153fcf104530f018fe38669192c5abc7492b1cecd00502a5dc39d6f13f21e.jpeg",
    "https://cdn.faire.com/fastly/03b4e439d5ed7143b11129a90ca61f990a16ec81f61e8ad270a71053188061ff.jpeg",
    "https://cdn.faire.com/fastly/4afc59fb9cd2ea64d3f2ad1c8414e6d934159bb0510f7f57d11489625df27ced.jpeg",
  ],
  priceDollars: 20,
  description:
    "Add a touch of nature-inspired elegance to your dining experience with the Casa Amarosa Circular serving dish . Made from high-quality ceramic material. Perfect for serving appetizers, snack, or even desserts, this versatile dish is easy to clean and dishwasher/microwave safe.\n\nWhether hosting a dinner or enjoying a cozy meal with your loved ones, the Casa Amarosa Circular serving dish is perfect for any occasion. It's a great gift for anyone who loves unique and stylish dinnerware. Shop now and elevate your dining experience with this beautiful Circular serving dish from Casa Amarosa.\n\n• Material - Ceramic\n• Size- 6.3X6.3 Inches\n• Color -Red\n• Dishwasher & Microwave safe\n• Hand Made in India \n\nMOQ 6\n\nFeatures: Unique vintage stripe handpainted glaze design\n\nDisclaimer: This product is handmade. There maybe minor imperfections in print, shape, size, and colour which are inherent to the process and what makes it unique. Actual colors may vary slightly due to your screen. \n",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:33.983Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
